import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table deposit report view.
 * @extends JetView
 */
export default class recordTableDepositReportView extends JetView {
    /**
     * Configures the view layout and properties.
     * @returns {Object} The configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Specifies the view type as datatable
            select: true, // Enables row selection
            columns: [
                // Defines the columns of the datatable
                {
                    id: 'package', // Unique identifier for the column
                    header: _('dav'), // Header text, localized
                    fillspace: 2, // Column width configuration
                    minWidth: 100, // Minimum width of the column
                    sort: 'text', // Sorting type for the column
                    format: dateFormat, // Formatting function for the column data
                },
                {
                    id: 'maintainer', // Unique identifier for the column
                    header: _('ID Usuario'), // Header text, localized
                    width: 100, // Fixed width of the column
                    sort: 'int', // Sorting type for the column
                },
                {
                    id: 'architecture', // Unique identifier for the column
                    header: _('Transacción ID'), // Header text, localized
                    width: 100, // Fixed width of the column
                    sort: 'int', // Sorting type for the column
                },
            ],
            loadahead: 0, // Configuration for data loading
            datafetch: devConfig.getDefaultDataFetch(), // Fetching default data configuration
            pager: 'pagerA', // Pager configuration for the datatable
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Retrieves the current user parameter
        this.on(this.app, 'user:id', (Id) => {
            // Event listener for user ID changes
            grid.load(
                // Loads data into the grid
                devConfig.geturlApi() + // Base API URL
                    'es/Financial/GetDepositsWithdrawalsWithPaging2' + // API endpoint
                    '?id=' + // Query parameter for user ID
                    Id, // User ID value
            );
        });
    }
}

// FILE DOCUMENTED
